export function buildFreeTrial100UsageHref({
  suggestedPlan,
  accountId,
  currentPlan,
}: {
  suggestedPlan: string;
  accountId: number;
  currentPlan: string;
}) {
  const subject = 'Free Trial Usage Reached – Assistance Requested';
  const body = `Hello Prerender team,

I am currently on a free trial with the Starter plan and I already used 100% of all my renders.
My suggested plan is: ${suggestedPlan}, what are my options?
Account ID: ${accountId}
Current Plan: ${currentPlan}
Suggested Plan: ${suggestedPlan}
`;

  return `mailto:support@prerender.io?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function buildFreeTrial115UsageHref({
  suggestedPlan,
  accountId,
  currentPlan,
}: {
  suggestedPlan: string;
  accountId: number;
  currentPlan: string;
}) {
  const subject = 'Free Trial Rendering Stopped – Assistance Requested';
  const body = `Hello Prerender team,

I am currently on a free trial with the Starter plan and I already used 115% of all my renders.
My suggested plan is: ${suggestedPlan}, what are my options?
Account ID: ${accountId}
Current Plan: ${currentPlan}
Suggested Plan: ${suggestedPlan}
`;

  return `mailto:support@prerender.io?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function buildTrialEndedNotIntegrated({ accountId }: { accountId: number }) {
  const subject = 'Trial ended while not integrated';
  const body = `Hello Prerender team,

I currently finished my free trial period, but I didn't manage to integrate Prerender.io.
Would it be possible to have an another one?

Account ID: ${accountId}
`;

  return `mailto:support@prerender.io?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
